import { combineReducers } from 'redux'
import app from './app-reducer'
import contentful from './contentful-reducer'
import elasticsearch from './elasticsearch/elasticsearch-reducer'
import { filtersReducer } from './filters/filters-reducer'
import { productTablesReducer } from './product-tables/product-table-reducer'
import { calculatorsReducer } from './calculators/calculators-reducer'
import componentReducer from './component/component-reducer'
import { sortReducer } from './sorts/sort-reducers'
import profileReducer from './lead-form/lead-form-reducer'
import reviewsReducer from './reviews/reviews-reducer'

export default combineReducers({
  app,
  contentful,
  elasticsearch,
  filters: filtersReducer,
  productTables: productTablesReducer,
  calculators: calculatorsReducer,
  components: componentReducer,
  sorts: sortReducer,
  profile: profileReducer,
  reviews: reviewsReducer,
})
